<ng-template #rosterCreate_pop>
  <div class="modal-header" *ngIf="isShowModal">
    <div class="pull-left" class="modal_title">New Order !</div>
    <button
      type="button"
      class="modal_close"
      (click)="closeModal()"
      aria-label="Close"
    >
      <span aria-hidden="true" class="">&times;</span>
    </button>
  </div>
  <div
    class="modal-body"
    style="
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
    "
  >
    <img
      src="/assets/images/page_icon/notification.png"
      style="padding: 45px 50px"
    />
    <button
      class="btn theme-btn-secondary"
      type="submit"
      (click)="handleViewOrderClick()"
    >
      View Order
    </button>
  </div>
  <!-- </div>
    </div>
    </div> -->
</ng-template>
